import React from 'react';
import { useIsEmbeddedMobile } from '../../../../../_hooks/useIsEmbeddedMobile';
import { DesktopTotals } from './DesktopTotals/DesktopTotals';
import { MobileTotals } from './MobileTotals/MobileTotals';

interface Props {
  gainLossTotals: {
    shortTerm: number;
    longTerm: number;
    total: number;
  };
  title: string;
}

export const Totals = ({ gainLossTotals, title }: Props) => {
  const isEmbeddedMobile = useIsEmbeddedMobile();

  if (isEmbeddedMobile) {
    return <MobileTotals {...gainLossTotals} title={title} />;
  }

  return <DesktopTotals {...gainLossTotals} title={title} />;
};
